import { SET_MODAL, SET_TAB, USER_INFO_FETCH_SUCCEEDED } from '../constants'

const appSettingsInitialState = {
  currentTab: 'text_box1',
  modalText: false,
  userInfo: false,
}

export const appSettingsReducer = (state = appSettingsInitialState, action) => {
  switch (action.type) {
    case USER_INFO_FETCH_SUCCEEDED:
      return {
        ...state,
        userInfo: action.userInfo,
      }
    case SET_TAB:
      return {
        ...state,
        currentTab: action.tab,
      }
    case SET_MODAL:
      return {
        ...state,
        modalText: action.modalText,
      }
    default:
      return state
  }
}
